(function(){
"use strict";

angular.module("swapick")
.factory('DataServiceRestangular', DataServiceRestangular);

function DataServiceRestangular(Restangular, baseServerUrl){
    return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(baseServerUrl);

        // Example configuration of httpFields
        RestangularConfigurer.setDefaultHttpFields({
            //'withCredentials': false
        });

        /* Custom response extractor for Restangular  */
        /* This one plays well with djangorestframework */

        RestangularConfigurer.setResponseExtractor(function(response, operation, what, url) {
        var newResponse;
        if (operation === "getList") {
            newResponse = response.items != undefined ? response.items : response;
            newResponse.metadata = {
                count : response.total_items,
                next : response.next,
                previous : response.prev,
                //number : response.number,
            }
        } else {
            newResponse = response;
        }
            return newResponse;
        });


        /* Restangular requestSuffix, appended to all urls -- plays well with django */
        /*
        RestangularConfigurer.setRequestSuffix('/?');
        */

    });
}

angular.module("swapick")
.factory('DataService', DataService);

function DataService(DataServiceRestangular, clientId, clientSecret){
    var svc = {};
    // Example restangular service. See also modules/config/network-config
    // for global restangular config.
    // Can do things like svc.something.one(id).get() or svc.something.getList()
    // and get back restangularized objects.

    svc.base = DataServiceRestangular;

    svc.me = DataServiceRestangular.oneUrl("api/user");
    svc.ecoins = svc.me.oneUrl("ecoins");
    svc.categories = DataServiceRestangular.oneUrl("api/categories");
    svc.districts = DataServiceRestangular.oneUrl("api/districts");
    svc.items = DataServiceRestangular.service("api/items");
    svc.owned = DataServiceRestangular.all("api/haves");

    svc.wanted = DataServiceRestangular.all("api/wants");
    svc.swaps = DataServiceRestangular.all("api/swaps");
    svc.messages = DataServiceRestangular.service("api/messages");
    svc.interests = DataServiceRestangular.service("api/interests");

    svc.services = DataServiceRestangular.all("api/services");
    svc.packages = DataServiceRestangular.all("api/packages");

    svc.itemsIcanGet = DataServiceRestangular.oneUrl("/api/swaps/items/get");
    svc.itemsIcanGive = DataServiceRestangular.oneUrl("/api/swaps/items/give");
    svc.lostPassword =  DataServiceRestangular.all("/api/passwords/resets");

    svc.users = DataServiceRestangular.all("/api/users");
    svc.userinfo = DataServiceRestangular.all("/api/userinfo");

    svc.baseAttributeValues = DataServiceRestangular.oneUrl("/api/attributes")
    svc.devices = DataServiceRestangular.all("/api/users/devices");
    svc.device = DataServiceRestangular.oneUrl("/api/user/device");

    svc.buyService = DataServiceRestangular.all("/api/services/buys");
    svc.boughtServices = DataServiceRestangular.all("/api/services/bought");




    svc.getToken = function(grantType, options){
        let params = {
            client_id : clientId,
            client_secret : clientSecret,
            grant_type : grantType
        }
        angular.extend(params, options);
        return DataServiceRestangular.oneUrl("oauth/v2/token").get(params);
    }

    svc.getClientToken = function(){
        return svc.getToken('client_credentials')
    }

    svc.getPasswordToken = function(username, password){
        return svc.getToken('password', {username, password})
    }

    svc.refreshToken = function(refreshToken){
        return svc.getToken('refresh_token', { refresh_token : refreshToken })
    }

    return svc;
}


angular.module("swapick")
.factory('DataStrategies', DataStrategies);

function DataStrategies(DataService, $ionicScrollDelegate, $q, $timeout){
    var svc = {};

    svc.createPagerMethods = (target, $scope, userOpts) => {

      let defaultOpts = {
        method: null,
        callMethodName:'getList',
        pageSize:50,
        params:{},
        itemsTransformer : null,
        hasSearch : true
      }

      let options = angular.extend(defaultOpts, userOpts)

      target._meta = {};
      target.objects = target.objects || [];

      let loadPage = (!options || !options.method || target.loadPage) ? target.loadPage : reset => {

        if(target._canceler){
          console.info("loading already - cancelling")
          target._canceler.resolve();
          target._canceler = null;
        }

        target._canceler = $q.defer();
        let baseOpts = { limit: options.pageSize, offset: reset ? 0 : target.objects.length};
        let opts = angular.extend(baseOpts, angular.isFunction(options.params) ? options.params() : options.params);

        let o;
        if(options.method.withHttpConfig){
          o = options.method.withHttpConfig({timeout: target._canceler.promise})
        } else {
          o = options.method;
        }

        target.loading = o[options.callMethodName](opts)
        .then(resp => {

          target.firstLoad = true;

          if(reset){
            target.objects.splice(0, target.objects.length);
          }
          let items = options.itemsGetter ? options.itemsGetter(resp) : resp;
          let transformedItems = options.itemsTransformer ? options.itemsTransformer(items) : resp;
          let finalObjects = target.objects.concat(transformedItems);
          target.objects = options.finalObjectsTransformer ? options.finalObjectsTransformer(finalObjects) : finalObjects;


          target._meta = resp.metadata || resp ;
          if(items && items.length){
            $ionicScrollDelegate.resize();
          }
          // FIXME: This because sometimes API pagination lie!
          if (items.length === 0) {
            target._meta.next = false;
          }

          // Stop loading request is OK
          target.loading = null;
          target._canceler = null;

          return items;
        })
        .catch((r) => {
          // Prevent to stop loading when requst was canceled...
          if (r.status !== -1) {
            target.loading = null;
            target._canceler = null;
          }
        })

        return target.loading;

      }

      target.loadPage = loadPage;

      target.hasMoreToLoad = () =>{
        return target._meta.next;
      }

      target.loadMore = () => {
        return target.loadPage().then(()=>{
          return $scope.$broadcast('scroll.infiniteScrollComplete');
        })
      }

      target.doRefresh = () => {
        console.log("t", target)
        return target.loadPage(true).then(()=>{
          return $scope.$broadcast('scroll.refreshComplete');
        })
      }

      //search methods
      if(options.hasSearch){
        target.searchActive = false;
        target.searchString = null;

        target.toggleSearch = ()=>{
          //reset query
          if(target.searchActive){
            target.searchString = null;
            target.loadMore();
          }
          target.searchActive = !target.searchActive;

          if(target.searchActive){
            $timeout(()=>{
              const input = document.querySelector(".search-input")
              if(input){
                input.focus();
              }
            });
          }

        }

        target.search = () => {

          target.objects = [];
          return target.loadPage()

        }
      }
      //search methods end

    }

    return svc;
}


})();



// WEBPACK FOOTER //
// ./src/services/data-service.js